import { atom } from 'recoil';

export const iframeEmail = atom({
  key: 'iframeEmail',
  default: false,
});
